exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.taginput-sortable .tag {\n  cursor: grab !important;\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/extensions/sortablejs/examples/ExSimple.vue"],"names":[],"mappings":";AACA;EACE,wBAAwB;CACzB","file":"ExSimple.vue","sourcesContent":["\n.taginput-sortable .tag {\n  cursor: grab !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4b9709e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./docs/pages/extensions/sortablejs/examples/ExSimple.vue
// module id = 1290
// module chunks = 38 45